/** @format */

import React from 'react';
import {
  InstantSearch,
  Hits,
  Pagination,
  Configure,
} from 'react-instantsearch';
import SearchResult from '@components/search/search-components/search-result';
import SearchFacets from './search-facets';
import NoResultsBoundary from './no-results-boundary';
import { safeCurrentLanguage } from '@services/drupal-services';
import { SEARCH_CLIENT } from '@components/search/algolia';
import SimpleAutocompleteSearch from './autocomplete-search-simple';
import { useSafeTranslate } from '@hooks/use-safe-translate';
import SearchPromotion from '@components/search/search-promotion/search-promotion';

/**
 * Search Page.
 */
const SearchPage = (): JSX.Element => {
  const placeholderText = useSafeTranslate('Start typing to search', true);

  return (
    <div className="search-page">
      <InstantSearch
        searchClient={SEARCH_CLIENT}
        indexName={`crawler_varian_fullvarian-full`}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
        routing>
        <div className="search-bar">
          <SimpleAutocompleteSearch
            searchClient={SEARCH_CLIENT}
            placeholder={placeholderText ?? ''}
            detachedMediaQuery="none"
            openOnFocus
          />
        </div>
        <NoResultsBoundary>
          <div className="grid-1-3-columns">
            <div className="search-facets">
              <SearchFacets />
            </div>
            <div className="search-main">
              {/* Start - Custom search promotions */}
              <div className="search-promotions">
                <SearchPromotion
                  title={
                    'Introducing RapidArc Dynamic, a radical transformation in planning and delivery.'
                  }
                  description={
                    '<span class="font-size-base font-semibold">A single solution. A spectrum of possibilities.</span><br /><span class="font-size-sm">CE Marked. 510(k) pending. Not available for sale in all markets and no guarantee of commercialization or feature availability.</span>'
                  }
                  linkText={'Learn more'}
                  linkUrl={
                    'https://www.varian.com/products/radiotherapy/treatment-planning/rapidarc-dynamic'
                  }
                  id={'rad-promotion'}
                  expireTime={30}
                  endPromotion={'2024-10-31'}
                />
              </div>
              {/* End - Custom search promotions */}

              <Configure
                hitsPerPage={10}
                filters={`language:${safeCurrentLanguage()}`}
              />
              <Hits hitComponent={SearchResult} />
              <Pagination />
            </div>
          </div>
        </NoResultsBoundary>
      </InstantSearch>
    </div>
  );
};
export default SearchPage;
